<template>
  <v-container>
    <v-dialog
      width="700"
      :value="isOpenBookmarkModal"
      persistent
      @click="isCloseBookmarkModal"
      @click:outside="isCloseBookmarkModal"
    >
      <div v-if="modalState===0">
        <BookmarkUploadModal :isCloseBookmarkModal="isCloseBookmarkModal" :changeModalState="changeModalState" />
      </div>
      <div v-else-if="modalState===1">
        <BookmarkSelectModal
          :changeModalState="changeModalState"
          :addInput="addInput"
          :isCloseBookmarkModal="isCloseBookmarkModal"
          :topic="topic"
        />
      </div>
    </v-dialog>
  </v-container>
</template>
<script>
import BookmarkUploadModal from '../organisms/BookmarkUploadModal.vue';
import BookmarkSelectModal from '../organisms/BookmarkSelectModal.vue';
import IconButton from '../atoms/IconButton.vue';
export default {
  data() {
    return {
      loading: false,
      modalState: 0
    };
  },
  name: 'BookmarkModal',
  props: [
    'isOpenBookmarkModal',
    'isCloseBookmarkModal',
    'addInput',
    'topic'
  ], 
  components: {
    BookmarkUploadModal,
    BookmarkSelectModal,
    IconButton,
  },
  methods: {
    changeModalState(changedNumber) {
      this.modalState = changedNumber;
    }
  },
}
</script>
<style scoped>
</style>